/** @type {Record<string, import("./types.js").GuideRouteMeta>} */
export const guideRoutesNl = {
  "how": {
    "title": "Hoe het werkt | Plaatplan",
    "description": "Van standaardplaat en deelprojecten tot werkplan: zo plan je zaagwerk in Plaatplan, stap voor stap."
  },
  "werkplanExport": {
    "title": "Werkplan printen of als PDF opslaan | Plaatplan",
    "description": "Open het werkplan vanuit de planner, stel in onder Voorbereiden, controleer de Zaagopdracht en sla op als PDF voor de bouwmarkt of zaagservice."
  },
  "cutSimulator": {
    "title": "Zaagvolgorde controleren | Plaatplan",
    "description": "Controleer thuis op desktop de zaagvolgorde in het werkplan. Zo begrijp je genummerde zaagsneden vóór je print of naar de zaagwinkel gaat."
  },
  "importExport": {
    "title": "Project importeren en exporteren | Plaatplan",
    "description": "Backup maken met een projectbestand (.json), importeren op een ander apparaat, en het verschil met PDF- of CSV-export."
  }
};
